export const URLS = {
  CONTACT_LENSES_BY_ID:
    "/wcs/resources/store/{storeId}/catalog/{catalogId}/contactlenses/byId/{productId}",
  DOWNLOAD_PRESCRIPTION_FILE:
    "/wcs/resources/store/{storeId}/wcs/prescription/download/{fileName}?nocache={noCache}",
};
